import { Bar, mixins } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
    extends: Bar,
    mixins: [mixins.reactiveProp],
    props: ['chartData', 'isLegendVisible'],
    mounted() {
        this.addPlugin(ChartDataLabels);
        this.renderChart(
            this.chartData,
            {
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 50,
                        bottom: 0
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            stepSize: 1,
                        }
                    }]
                },
                plugins: {
                    datalabels: {
                        anchor: 'end',
                        clamp: true,
                        align: 'top',
                        color: '#555',
                        backgroundColor: "#ddd",
                        borderWidth: '1',
                        font: {
                            size: 16,
                        },
                        padding: {
                            top: 5,
                            left: 12,
                            right: 12,
                            bottom: 5
                        },
                        formatter: function(value, context) {
                            if (value === 0) { return null }
                            return value;
                        }
                    }
                },
                legend: {
                    display: this.isLegendVisible,
                    align: 'start',
                    labels: {
                        padding: 15,
                        usePointStyle: true
                    }
                },
                maintainAspectRatio: false
            }
        );
    }
}